var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blocked",on:{"click":function($event){return _vm.back()}}},[_c('div',[_vm._v("你的账户已被冻结，请联系管理员解冻")])])
}
var staticRenderFns = []

export { render, staticRenderFns }